export enum ContentPaginationActions {
  next = 'next',
  previous = 'previous',
}
